import { Dispatch } from 'redux'
import requestCreateEvent from '../../../actions/bookingCalendar/event/requestCreateEvent'
import requestUpdateEvent from '../../../actions/bookingCalendar/event/requestUpdateEvent'

export function onSubmitCreate(formName: string) {
  return function(values, dispatch: Dispatch) {
    dispatch(requestCreateEvent(values, formName))
  }
}

export function onSubmitUpdate() {
  return function(values, dispatch: Dispatch) {
    dispatch(requestUpdateEvent(values))
  }
}
